import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@app/core/okta-auth.guard';
import { TeamManagementComponent } from './team-management/team-management.component';
import { RtoDetailsComponent } from './rto-details/rto-details.component';
import { TeamCompositionDetailsComponent } from './team-composition-details/team-composition-details.component';
import { TeamPerformanceDetailsComponent } from './team-performance-details/team-performance-details.component';

const routes: Routes = [
   {
    path: 'team-management',
    canActivate: [AuthGuard],
    children: [
      { path: '', component: TeamManagementComponent },
      { path: 'rto-details', component: RtoDetailsComponent },
      { path: 'team-composition', component: TeamCompositionDetailsComponent },
      { path: 'performance-details', component: TeamPerformanceDetailsComponent },
      { path: '**', redirectTo: '', pathMatch: 'full' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TeamManagementRoutingModule {}
